import React from "react";
const CompanyPromotion = () => {
  return (
    <div>
      <h3 style={{ marginTop: "40px" }}>Certified Developers</h3>
      <p>
        Kryzen Biotech strives to create the most productive models for new-age
        urban farmers. We have combine sustainable technology and modern farming
        techniques in order to achieve high yields, while also being mindful of
        our environment's sustainability needs.
      </p>

      <div
        style={{
          display: "flex",

          justifyContent: "center",
          width: "100%",
          marginTop: "12px",
        }}
      >
        <img
          src={
            "https://res.cloudinary.com/dsmabnook/image/upload/v1749638799/peyush_kkabwt_cmtdx3.jpg"
          }
          width={"95%"}
          alt="kryzenCertificates"
        />
      </div>
      <div
        style={{
          display: "flex",

          justifyContent: "center",
          width: "100%",
          marginTop: "12px",
        }}
      >
        <img
          src={
            "https://res.cloudinary.com/dsmabnook/image/upload/v1749637173/kryzencertificates_ms0k0w_dprefs.png"
          }
          width={"95%"}
          alt="kryzenCertificates"
        />
      </div>
      <div className="p-4 ps-2 text-uppercase">
        <h3
          style={{
            fontSize: "3.3rem",
          }}
          className="pb-3"
        >
          <span style={{ color: "green" }}>Brands</span>
        </h3>
        <h3 style={{ fontSize: "3.3rem" }}>We work with.</h3>
      </div>
      <div>
        <div className="row row-deck gap-3">
          <img
            className="col"
            src={
              "https://res.cloudinary.com/bsgfcooa/image/upload/v1763527740/1_egldkp.png"
            }
            alt="KBPL works with"
          />
          <img
            className="col"
            src={
              "https://res.cloudinary.com/bsgfcooa/image/upload/v1763527740/2_gnc5fi.png"
            }
            alt="KBPL works with"
          />
          <img
            className="col"
            src={
              "https://res.cloudinary.com/bsgfcooa/image/upload/v1763527742/3_cl8gnl.png"
            }
            alt="KBPL works with"
          />
          <img
            className="col"
            src={
              "https://res.cloudinary.com/bsgfcooa/image/upload/v1763527745/4_kzsjeh.png"
            }
            alt="KBPL works with"
          />
          <img
            className="col"
            src={
              "https://res.cloudinary.com/bsgfcooa/image/upload/v1763527748/5_hmtft5.png"
            }
            alt="KBPL works with"
          />
        </div>
        <div className="row row-deck gap-3 mt-3">
          <img
            className="col"
            src={
              "https://res.cloudinary.com/bsgfcooa/image/upload/v1763527749/6_qaw0qx.png"
            }
            alt="KBPL works with"
          />
          <img
            className="col"
            src={
              "https://res.cloudinary.com/bsgfcooa/image/upload/v1763527753/7_ausznd.png"
            }
            alt="KBPL works with"
          />
          <img
            className="col"
            src={
              "https://res.cloudinary.com/bsgfcooa/image/upload/v1763527753/8_lqlrmv.png"
            }
            alt="KBPL works with"
          />
          <img
            className="col"
            src={
              "https://res.cloudinary.com/bsgfcooa/image/upload/v1763527755/9_evfhin.png"
            }
            alt="KBPL works with"
          />
          <img
            className="col"
            src={
              "https://res.cloudinary.com/bsgfcooa/image/upload/v1763527759/10_jcadpw.png"
            }
            alt="KBPL works with"
          />
        </div>
      </div>
      <div
        className="html2pdf__page-break"
        style={{ pageBreakAfter: "always", display: "block", clear: "both" }}
      ></div>
      <div className="p-4 ps-2">
        <h3
          style={{
            fontSize: "3.3rem",
          }}
          className="pb-3"
        >
          We are
        </h3>
        <h3
          style={{
            fontSize: "3.3rem",
          }}
          className="pb-3"
        >
          <span style={{ color: "green" }}>FASTEST GROWING CEA</span>
        </h3>
        <h3 style={{ fontSize: "3.3rem" }}>
          developer in <span style={{ color: "green" }}>India!</span>
        </h3>
      </div>

      <table style={{ width: "100%" }}>
        <tbody>
          <tr>
            <td style={{ width: "20%" }}>
              <h2
                style={{
                  fontSize: "1.5em",
                  margin: "0px",
                  padding: "0px",
                  textAlign: "center",
                }}
              >
                40,20,789+
              </h2>
              <p
                style={{
                  margin: "0px",
                  fontWeight: "bold",
                  padding: "0px",
                  textAlign: "center",
                }}
              >
                SqFt area developed
              </p>
            </td>
            <td style={{ width: "20%" }}>
              <h2
                style={{
                  fontSize: "1.5em",
                  margin: "0px",
                  padding: "0px",
                  textAlign: "center",
                }}
              >
                82,000+
              </h2>
              <p
                style={{
                  margin: "0px",
                  fontWeight: "bold",
                  padding: "0px",
                  textAlign: "center",
                }}
              >
                People trained
              </p>
            </td>

            <td style={{ width: "20%" }}>
              <h2
                style={{
                  fontSize: "1.5em",
                  margin: "0px",
                  padding: "0px",
                  textAlign: "center",
                }}
              >
                515+
              </h2>
              <p
                style={{
                  margin: "0px",
                  fontWeight: "bold",
                  padding: "0px",
                  textAlign: "center",
                }}
              >
                Site Inspections
              </p>
            </td>
            <td style={{ width: "20%" }}>
              <h2
                style={{
                  fontSize: "1.5em",
                  margin: "0px",
                  padding: "0px",
                  textAlign: "center",
                }}
              >
                245+
              </h2>
              <p
                style={{
                  margin: "0px",
                  fontWeight: "bold",
                  padding: "0px",
                  textAlign: "center",
                }}
              >
                Projects delivered
              </p>
            </td>
          </tr>
        </tbody>
      </table>
      <div
        style={{
          display: "flex",
          justifyContent: "center",
          width: "100%",
          objectFit: "contain",
          marginTop: "12px",
        }}
      >
        <img
          src={
            "https://res.cloudinary.com/dsmabnook/image/upload/v1749637281/whyWeChooseKBPL_nwyh7d_xliuvq.png"
          }
          width={"100%"}
          alt="kryzenCertificates"
        />
      </div>
      <div
        className="html2pdf__page-break"
        style={{ pageBreakAfter: "always", display: "block", clear: "both" }}
      ></div>
    </div>
  );
};

export default CompanyPromotion;
